
/* eslint-disable no-undef */
// window.$ = window.jQuery = require('jquery')
require('sweetalert')



// WEBPACK FOOTER //
// ./src/includes.js